document.addEventListener("DOMContentLoaded", () => {
    let timers = document.querySelectorAll('.lp-timer');

    timers.forEach((timer) => {
        const timeUnits = timer.querySelectorAll('.lp-timer__time-unit');
        const countDownDate = new Date(timer.getAttribute('data-date')).getTime();

        if (timeUnits.length < 4 || Number.isNaN(countDownDate)) {
            return;
        }

        const updateTimer = function () {
            var d = new Date();
            var now = d.getTime() - d.getTimezoneOffset() * 60 * 1000

            let distance = countDownDate + 86400000 - now;
            let days = Math.floor(distance / (1000 * 60 * 60 * 24));
            if (days < 10) {
                days = ("0" + days).slice(-2);
            }
            let hours = Math.floor((distance % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
            hours = ("0" + hours).slice(-2);
            let minutes = Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60));
            minutes = ("0" + minutes).slice(-2);
            let seconds = Math.floor((distance % (1000 * 60)) / 1000);
            seconds = ("0" + seconds).slice(-2);

            timeUnits[0].querySelector('strong').textContent = days;
            timeUnits[1].querySelector('strong').textContent = hours;
            timeUnits[2].querySelector('strong').textContent = minutes;
            timeUnits[3].querySelector('strong').textContent = seconds;

            if (distance < 0) {
                clearInterval(interval);
                timeUnits[0].querySelector('strong').textContent = '0';
                timeUnits[1].querySelector('strong').textContent = '0';
                timeUnits[2].querySelector('strong').textContent = '0';
                timeUnits[3].querySelector('strong').textContent = '0';
            }
        };

        updateTimer();

        let interval = setInterval(updateTimer, 1000);
    });

})
